import { render, staticRenderFns } from "./CountryCodes.vue?vue&type=template&id=21c12b7f&scoped=true&"
import script from "./CountryCodes.vue?vue&type=script&lang=js&"
export * from "./CountryCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c12b7f",
  null
  
)

export default component.exports